// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Badge-module__font-s-10___GmlkG {
  font-size: 10px !important;
}

.Badge-module__font-s-12___poyBR {
  font-size: 12px !important;
}

.Badge-module__font-s-13___niDAs {
  font-size: 13px !important;
}

.Badge-module__font-s-14___NtMUm {
  font-size: 14px !important;
}

.Badge-module__font-s-15___lTBnZ {
  font-size: 15px !important;
}

.Badge-module__font-s-16___eY04w {
  font-size: 16px !important;
}

.Badge-module__font-s-18___bPCpc {
  font-size: 18px !important;
}

.Badge-module__font-s-20___nJ82X {
  font-size: 20px !important;
}

.Badge-module__font-s-22___F4usS {
  font-size: 22px !important;
}

.Badge-module__font-s-28___N5LJG {
  font-size: 28px !important;
}

.Badge-module__font-w-400___SrGNj {
  font-weight: 400 !important;
}

.Badge-module__font-w-500___Hu9q9 {
  font-weight: 500 !important;
}

.Badge-module__font-w-600___FgeBX {
  font-weight: 600 !important;
}

.Badge-module__font-w-700___o4y9o {
  font-weight: 700 !important;
}

.Badge-module__p-5___wZWPY {
  padding: 5px !important;
}

.Badge-module__p-12___FOkcp {
  padding: 12px !important;
}

.Badge-module__p-16___vVeMl {
  padding: 16px !important;
}

.Badge-module__p-30___F4Wo3 {
  padding: 30px !important;
}

.Badge-module__p-b-0___Uf8h8 {
  padding-bottom: 0 !important;
}

.Badge-module__p-b-5___Lcjql {
  padding-bottom: 5px !important;
}

.Badge-module__p-b-10___CMJm_ {
  padding-bottom: 10px !important;
}

.Badge-module__p-b-12___Ip8oz {
  padding-bottom: 12px !important;
}

.Badge-module__p-b-16___QVNlo {
  padding-bottom: 16px !important;
}

.Badge-module__p-b-18___oLnWC {
  padding-bottom: 18px !important;
}

.Badge-module__p-b-20___Y4zSE {
  padding-bottom: 20px !important;
}

.Badge-module__p-b-25___kqhL3 {
  padding-bottom: 25px !important;
}

.Badge-module__p-b-30___I4SPF {
  padding-bottom: 30px !important;
}

.Badge-module__p-b-50___s5IQJ {
  padding-bottom: 50px !important;
}

.Badge-module__p-t-0___ebKBd {
  padding-top: 0 !important;
}

.Badge-module__p-t-12___rO1QO {
  padding-top: 12px !important;
}

.Badge-module__p-t-16___G9Eyn {
  padding-top: 16px !important;
}

.Badge-module__p-t-18___qs__6 {
  padding-top: 18px !important;
}

.Badge-module__p-t-20___C1FM8 {
  padding-top: 20px !important;
}

.Badge-module__p-t-30___m5W7b {
  padding-top: 30px !important;
}

.Badge-module__p-t-40___pmROS {
  padding-top: 40px !important;
}

.Badge-module__p-t-50___aS3f3 {
  padding-top: 50px !important;
}

.Badge-module__p-l-20___NeTEv {
  padding-left: 20px !important;
}

.Badge-module__p-l-30___Ccr5S {
  padding-left: 30px !important;
}

.Badge-module__p-l-40___FKlQ_ {
  padding-left: 40px !important;
}

.Badge-module__p-r-16___JBtit {
  padding-right: 16px !important;
}

.Badge-module__p-r-20___aDUBc {
  padding-right: 20px !important;
}

.Badge-module__p-r-30___ETEjB {
  padding-right: 30px !important;
}

.Badge-module__p-r-50___apYO1 {
  padding-right: 50px !important;
}

.Badge-module__p-r-60___PqTrH {
  padding-right: 60px !important;
}

.Badge-module__m-b-1___xxwYt {
  margin-bottom: 1px !important;
}

.Badge-module__m-b-2___xhicK {
  margin-bottom: 2px !important;
}

.Badge-module__m-b-6___sjErm {
  margin-bottom: 6px !important;
}

.Badge-module__m-b-8___dmhvI {
  margin-bottom: 8px !important;
}

.Badge-module__m-b-10___y0Rxx {
  margin-bottom: 10px !important;
}

.Badge-module__m-b-14___fxDr_ {
  margin-bottom: 14px !important;
}

.Badge-module__m-b-16___cjKhv {
  margin-bottom: 16px !important;
}

.Badge-module__m-b-20____j6AE {
  margin-bottom: 20px !important;
}

.Badge-module__m-b-22___F0YwI {
  margin-bottom: 22px !important;
}

.Badge-module__m-b-24____9o_Z {
  margin-bottom: 24px !important;
}

.Badge-module__m-b-30___XoSu1 {
  margin-bottom: 30px !important;
}

.Badge-module__m-b-32___gJBlF {
  margin-bottom: 32px !important;
}

.Badge-module__m-b-40___gyN1f {
  margin-bottom: 40px !important;
}

.Badge-module__m-t-2___SWYRe {
  margin-top: 2px !important;
}

.Badge-module__m-t-3___MOZBc {
  margin-top: 3px !important;
}

.Badge-module__m-t-4___OsMhg {
  margin-top: 4px !important;
}

.Badge-module__m-t-5___oFEzJ {
  margin-top: 5px !important;
}

.Badge-module__m-t-8___eej28 {
  margin-top: 8px !important;
}

.Badge-module__m-t-10___lFE5n {
  margin-top: 10px !important;
}

.Badge-module__m-t-15___L9lPI {
  margin-top: 15px !important;
}

.Badge-module__m-t-16___zPe5F {
  margin-top: 16px !important;
}

.Badge-module__m-t-20___ArL94 {
  margin-top: 20px !important;
}

.Badge-module__m-t-22___O8oe7 {
  margin-top: 22px !important;
}

.Badge-module__m-t-30___I39xZ {
  margin-top: 30px !important;
}

.Badge-module__m-t-32___FKu6H {
  margin-top: 32px !important;
}

.Badge-module__m-l-auto___hI005 {
  margin-left: auto !important;
}

.Badge-module__m-l-4___oDQXT {
  margin-left: 4px !important;
}

.Badge-module__m-l-5___xRxj3 {
  margin-left: 5px !important;
}

.Badge-module__m-l-6___DFIca {
  margin-left: 6px !important;
}

.Badge-module__m-l-8___w7K0O {
  margin-left: 8px !important;
}

.Badge-module__m-l-10___rzmHF {
  margin-left: 10px !important;
}

.Badge-module__m-l-16___Nwi4S {
  margin-left: 16px !important;
}

.Badge-module__m-l-20___FSLnv {
  margin-left: 20px !important;
}

.Badge-module__m-l-24____QnNg {
  margin-left: 24px !important;
}

.Badge-module__m-l-30___HmI98 {
  margin-left: 30px !important;
}

.Badge-module__m-l-35___wCSul {
  margin-left: 35px !important;
}

.Badge-module__m-l-40___SbEgG {
  margin-left: 40px !important;
}

.Badge-module__m-r-8___f6SIl {
  margin-right: 8px !important;
}

.Badge-module__m-r-10___mp61i {
  margin-right: 10px !important;
}

.Badge-module__m-r-16___EjvD6 {
  margin-right: 16px !important;
}

.Badge-module__m-r-20___vH0Pe {
  margin-right: 20px !important;
}

.Badge-module__m-r-24___jZ2uI {
  margin-right: 24px !important;
}

.Badge-module__m-r-30___yLaMV {
  margin-right: 30px !important;
}

.Badge-module__m-r-40___kqcPb {
  margin-right: 40px !important;
}

.Badge-module__border-r-3___oO1Uy {
  border-radius: 3px !important;
}

.Badge-module__border-r-4___x4GF5 {
  border-radius: 4px !important;
}

.Badge-module__border-r-6___JanX8 {
  border-radius: 6px !important;
}

.Badge-module__border-r-10___gh3Pc {
  border-radius: 10px !important;
}

.Badge-module__border-r-12___k_cNu {
  border-radius: 12px !important;
}

.Badge-module__border-r-16___GZwho {
  border-radius: 16px !important;
}

.Badge-module__border-r-50___i1_VT {
  border-radius: 50% !important;
}

.Badge-module__primary-border___wGU5t {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Badge-module__primary-border-b___ElJG3 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Badge-module__primary-border-t___pyzVe {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Badge-module__primary-border-l___eZ5Bi {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Badge-module__primary-border-r___JSzvE {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Badge-module__secondary-border___c9MwS {
  border: 1px solid #637768;
}

.Badge-module__secondary-border-b___StONJ {
  border-bottom: 1px solid #637768;
}

.Badge-module__secondary-border-t___Zub8C {
  border-top: 1px solid #637768;
}

.Badge-module__secondary-border-l___J_F2_ {
  border-left: 1px solid #637768;
}

.Badge-module__secondary-border-r___ZCfGD {
  border-right: 1px solid #637768;
}

.Badge-module__gap-0___gurJ9 {
  gap: 0 !important;
}

.Badge-module__gap-2___k9zUR {
  gap: 2px !important;
}

.Badge-module__gap-4___wdX_g {
  gap: 4px !important;
}

.Badge-module__gap-5___M97ZU {
  gap: 5px !important;
}

.Badge-module__gap-6___TSjIp {
  gap: 6px !important;
}

.Badge-module__gap-8___p608d {
  gap: 8px !important;
}

.Badge-module__gap-10___pMxJY {
  gap: 10px !important;
}

.Badge-module__gap-12___FOZyJ {
  gap: 12px !important;
}

.Badge-module__gap-14___F0dss {
  gap: 14px !important;
}

.Badge-module__gap-16___hbMLM {
  gap: 16px !important;
}

.Badge-module__gap-18___WCSyg {
  gap: 18px !important;
}

.Badge-module__gap-20___miRpn {
  gap: 20px !important;
}

.Badge-module__gap-24___fP4OC {
  gap: 24px !important;
}

.Badge-module__gap-26___Z8Owk {
  gap: 26px !important;
}

.Badge-module__gap-30___aosAM {
  gap: 30px !important;
}

.Badge-module__gap-32___hca8A {
  gap: 32px !important;
}

.Badge-module__gap-40___RZQXM {
  gap: 40px !important;
}

.Badge-module__gap-50___PnCbV {
  gap: 50px !important;
}

.Badge-module__flex-1___UOdhl {
  flex: 1;
}

.Badge-module__flex-none___yZyBX {
  flex: none !important;
}

.Badge-module__flex-column___qEhnf {
  display: flex;
  flex-direction: column !important;
}

.Badge-module__flex-row___pajwa {
  display: flex;
  flex-direction: row !important;
}

.Badge-module__vertically-centered___ob6X6 {
  display: flex;
  align-items: center !important;
}

.Badge-module__horizontally-centered___FwIyA {
  display: flex;
  justify-content: center !important;
}

.Badge-module__horizontally-end___Kx1LT {
  display: flex;
  justify-content: end !important;
}

.Badge-module__vertically-start___CiUPX {
  display: flex;
  align-items: start !important;
}

.Badge-module__space-between___X3N_3 {
  display: flex;
  justify-content: space-between !important;
}

.Badge-module__flex-wrap___lcVzq {
  flex-wrap: wrap !important;
}

.Badge-module__height-100___KzDVK {
  height: 100%;
}

.Badge-module__width-50___WznE0 {
  width: 50% !important;
}

.Badge-module__width-100___ENdfv {
  width: 100%;
}

.Badge-module__cursor-pointer___qyLgy {
  cursor: pointer;
}

.Badge-module__cursor-not-allowed___H0ifR {
  cursor: not-allowed !important;
}

.Badge-module__absolute-centered___yvL_1 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Badge-module__absolute___qeYPD {
  position: absolute;
}

.Badge-module__relative___CWXhb {
  position: relative;
}

.Badge-module__fixed___qXost {
  position: fixed;
}

.Badge-module__visible___QqYC9 {
  opacity: 1;
}

.Badge-module__invisible___zorwL {
  opacity: 0;
}

.Badge-module__col-90___fND3g {
  width: 90% !important;
}

.Badge-module__col-auto___cy0yL {
  width: auto !important;
}

.Badge-module__medical-tabs___v9RON {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Badge-module__medical-table-new___KpdNc {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Badge-module__medical-table-new___KpdNc:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Badge-module__medical-table-new___KpdNc::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Badge-module__medical-table-new___KpdNc::-webkit-scrollbar-track {
  display: none;
}
.Badge-module__medical-table-new___KpdNc.Badge-module__no-pagination___EmU8E {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Badge-module__medical-table-new___KpdNc.Badge-module__no-pagination___EmU8E:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Badge-module__medical-table-new___KpdNc.Badge-module__no-pagination___EmU8E::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Badge-module__medical-table-new___KpdNc.Badge-module__no-pagination___EmU8E::-webkit-scrollbar-track {
  display: none;
}

.Badge-module__medical-table-empty___YoB0s {
  padding: 14px 40px !important;
}

.Badge-module__icon-btn___jZFUL {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Badge-module__search-icon___vd8u1 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Badge-module__disable-select___VOeEI {
  user-select: none;
}

.Badge-module__break-word___Yt9R5 {
  word-break: break-word;
}

.Badge-module__popup-clear-btn___dByfT {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Badge-module__scroll-m-b-20___BwC6E {
  scroll-margin-bottom: 20px;
}

.Badge-module__badge___b1jzG {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  line-height: 20px;
  padding: 0 7px;
  border-radius: 4px;
  font-weight: 500;
  white-space: nowrap;
  font-family: "IBM Plex Mono", monospace;
}

.Badge-module__default___LlD1t {
  background: #f4f4f5;
  color: #3f3f46;
  border: 1px solid #e4e4e7;
}

.Badge-module__outline___bTho8 {
  background: transparent;
  color: #52525b;
  border: 1px solid #d4d4d8;
}

.Badge-module__critical___L2PGO {
  background: #18181b;
  color: #fafafa;
  border: 1px solid #18181b;
}

.Badge-module__escalated___UXHn5 {
  background: #fefce8;
  color: #854d0e;
  border: 1px solid #fde68a;
  font-weight: 600;
}

.Badge-module__flagged___gbuj0 {
  background: #ffffff;
  color: #18181b;
  border: 1px solid #18181b;
  font-weight: 600;
}

.Badge-module__edge___QS8SV {
  background: #ffffff;
  color: #52525b;
  border: 1px dashed #a1a1aa;
}

.Badge-module__green___KDjiT {
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.Badge-module__yellow___MTiDE {
  background: #fefce8;
  color: #854d0e;
  border: 1px solid #fde68a;
}

.Badge-module__blue___h_EkL {
  background: #f0f9ff;
  color: #0369a1;
  border: 1px solid #bae6fd;
}

.Badge-module__orange___grOJw {
  background: #fff7ed;
  color: #c2410c;
  border: 1px solid #fed7aa;
}

.Badge-module__red___tt5sQ {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

.Badge-module__statusDot___X_xJG {
  width: var(--dot-size, 8px);
  height: var(--dot-size, 8px);
  border-radius: 50%;
  background: var(--dot-color, #d4d4d8);
  display: inline-block;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/Badge/Badge.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uCAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,0BAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,qCAAA;EACA,qBAAA;EACA,cAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 11px;\n  line-height: 20px;\n  padding: 0 7px;\n  border-radius: 4px;\n  font-weight: 500;\n  white-space: nowrap;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.default {\n  background: #f4f4f5;\n  color: #3f3f46;\n  border: 1px solid #e4e4e7;\n}\n\n.outline {\n  background: transparent;\n  color: #52525b;\n  border: 1px solid #d4d4d8;\n}\n\n.critical {\n  background: #18181b;\n  color: #fafafa;\n  border: 1px solid #18181b;\n}\n\n.escalated {\n  background: tone-color(warning, bg);\n  color: tone-color(warning, text);\n  border: 1px solid tone-color(warning, border);\n  font-weight: 600;\n}\n\n.flagged {\n  background: #ffffff;\n  color: #18181b;\n  border: 1px solid #18181b;\n  font-weight: 600;\n}\n\n.edge {\n  background: #ffffff;\n  color: #52525b;\n  border: 1px dashed #a1a1aa;\n}\n\n.green {\n  background: #f0fdf4;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n}\n\n.yellow {\n  background: #fefce8;\n  color: #854d0e;\n  border: 1px solid #fde68a;\n}\n\n.blue {\n  background: #f0f9ff;\n  color: #0369a1;\n  border: 1px solid #bae6fd;\n}\n\n.orange {\n  background: #fff7ed;\n  color: #c2410c;\n  border: 1px solid #fed7aa;\n}\n\n.red {\n  background: #fef2f2;\n  color: #991b1b;\n  border: 1px solid #fecaca;\n}\n\n.statusDot {\n  width: var(--dot-size, 8px);\n  height: var(--dot-size, 8px);\n  border-radius: 50%;\n  background: var(--dot-color, #d4d4d8);\n  display: inline-block;\n  flex-shrink: 0;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Badge-module__font-s-10___GmlkG`,
	"fontS12": `Badge-module__font-s-12___poyBR`,
	"fontS13": `Badge-module__font-s-13___niDAs`,
	"fontS14": `Badge-module__font-s-14___NtMUm`,
	"fontS15": `Badge-module__font-s-15___lTBnZ`,
	"fontS16": `Badge-module__font-s-16___eY04w`,
	"fontS18": `Badge-module__font-s-18___bPCpc`,
	"fontS20": `Badge-module__font-s-20___nJ82X`,
	"fontS22": `Badge-module__font-s-22___F4usS`,
	"fontS28": `Badge-module__font-s-28___N5LJG`,
	"fontW400": `Badge-module__font-w-400___SrGNj`,
	"fontW500": `Badge-module__font-w-500___Hu9q9`,
	"fontW600": `Badge-module__font-w-600___FgeBX`,
	"fontW700": `Badge-module__font-w-700___o4y9o`,
	"p5": `Badge-module__p-5___wZWPY`,
	"p12": `Badge-module__p-12___FOkcp`,
	"p16": `Badge-module__p-16___vVeMl`,
	"p30": `Badge-module__p-30___F4Wo3`,
	"pB0": `Badge-module__p-b-0___Uf8h8`,
	"pB5": `Badge-module__p-b-5___Lcjql`,
	"pB10": `Badge-module__p-b-10___CMJm_`,
	"pB12": `Badge-module__p-b-12___Ip8oz`,
	"pB16": `Badge-module__p-b-16___QVNlo`,
	"pB18": `Badge-module__p-b-18___oLnWC`,
	"pB20": `Badge-module__p-b-20___Y4zSE`,
	"pB25": `Badge-module__p-b-25___kqhL3`,
	"pB30": `Badge-module__p-b-30___I4SPF`,
	"pB50": `Badge-module__p-b-50___s5IQJ`,
	"pT0": `Badge-module__p-t-0___ebKBd`,
	"pT12": `Badge-module__p-t-12___rO1QO`,
	"pT16": `Badge-module__p-t-16___G9Eyn`,
	"pT18": `Badge-module__p-t-18___qs__6`,
	"pT20": `Badge-module__p-t-20___C1FM8`,
	"pT30": `Badge-module__p-t-30___m5W7b`,
	"pT40": `Badge-module__p-t-40___pmROS`,
	"pT50": `Badge-module__p-t-50___aS3f3`,
	"pL20": `Badge-module__p-l-20___NeTEv`,
	"pL30": `Badge-module__p-l-30___Ccr5S`,
	"pL40": `Badge-module__p-l-40___FKlQ_`,
	"pR16": `Badge-module__p-r-16___JBtit`,
	"pR20": `Badge-module__p-r-20___aDUBc`,
	"pR30": `Badge-module__p-r-30___ETEjB`,
	"pR50": `Badge-module__p-r-50___apYO1`,
	"pR60": `Badge-module__p-r-60___PqTrH`,
	"mB1": `Badge-module__m-b-1___xxwYt`,
	"mB2": `Badge-module__m-b-2___xhicK`,
	"mB6": `Badge-module__m-b-6___sjErm`,
	"mB8": `Badge-module__m-b-8___dmhvI`,
	"mB10": `Badge-module__m-b-10___y0Rxx`,
	"mB14": `Badge-module__m-b-14___fxDr_`,
	"mB16": `Badge-module__m-b-16___cjKhv`,
	"mB20": `Badge-module__m-b-20____j6AE`,
	"mB22": `Badge-module__m-b-22___F0YwI`,
	"mB24": `Badge-module__m-b-24____9o_Z`,
	"mB30": `Badge-module__m-b-30___XoSu1`,
	"mB32": `Badge-module__m-b-32___gJBlF`,
	"mB40": `Badge-module__m-b-40___gyN1f`,
	"mT2": `Badge-module__m-t-2___SWYRe`,
	"mT3": `Badge-module__m-t-3___MOZBc`,
	"mT4": `Badge-module__m-t-4___OsMhg`,
	"mT5": `Badge-module__m-t-5___oFEzJ`,
	"mT8": `Badge-module__m-t-8___eej28`,
	"mT10": `Badge-module__m-t-10___lFE5n`,
	"mT15": `Badge-module__m-t-15___L9lPI`,
	"mT16": `Badge-module__m-t-16___zPe5F`,
	"mT20": `Badge-module__m-t-20___ArL94`,
	"mT22": `Badge-module__m-t-22___O8oe7`,
	"mT30": `Badge-module__m-t-30___I39xZ`,
	"mT32": `Badge-module__m-t-32___FKu6H`,
	"mLAuto": `Badge-module__m-l-auto___hI005`,
	"mL4": `Badge-module__m-l-4___oDQXT`,
	"mL5": `Badge-module__m-l-5___xRxj3`,
	"mL6": `Badge-module__m-l-6___DFIca`,
	"mL8": `Badge-module__m-l-8___w7K0O`,
	"mL10": `Badge-module__m-l-10___rzmHF`,
	"mL16": `Badge-module__m-l-16___Nwi4S`,
	"mL20": `Badge-module__m-l-20___FSLnv`,
	"mL24": `Badge-module__m-l-24____QnNg`,
	"mL30": `Badge-module__m-l-30___HmI98`,
	"mL35": `Badge-module__m-l-35___wCSul`,
	"mL40": `Badge-module__m-l-40___SbEgG`,
	"mR8": `Badge-module__m-r-8___f6SIl`,
	"mR10": `Badge-module__m-r-10___mp61i`,
	"mR16": `Badge-module__m-r-16___EjvD6`,
	"mR20": `Badge-module__m-r-20___vH0Pe`,
	"mR24": `Badge-module__m-r-24___jZ2uI`,
	"mR30": `Badge-module__m-r-30___yLaMV`,
	"mR40": `Badge-module__m-r-40___kqcPb`,
	"borderR3": `Badge-module__border-r-3___oO1Uy`,
	"borderR4": `Badge-module__border-r-4___x4GF5`,
	"borderR6": `Badge-module__border-r-6___JanX8`,
	"borderR10": `Badge-module__border-r-10___gh3Pc`,
	"borderR12": `Badge-module__border-r-12___k_cNu`,
	"borderR16": `Badge-module__border-r-16___GZwho`,
	"borderR50": `Badge-module__border-r-50___i1_VT`,
	"primaryBorder": `Badge-module__primary-border___wGU5t`,
	"primaryBorderB": `Badge-module__primary-border-b___ElJG3`,
	"primaryBorderT": `Badge-module__primary-border-t___pyzVe`,
	"primaryBorderL": `Badge-module__primary-border-l___eZ5Bi`,
	"primaryBorderR": `Badge-module__primary-border-r___JSzvE`,
	"secondaryBorder": `Badge-module__secondary-border___c9MwS`,
	"secondaryBorderB": `Badge-module__secondary-border-b___StONJ`,
	"secondaryBorderT": `Badge-module__secondary-border-t___Zub8C`,
	"secondaryBorderL": `Badge-module__secondary-border-l___J_F2_`,
	"secondaryBorderR": `Badge-module__secondary-border-r___ZCfGD`,
	"gap0": `Badge-module__gap-0___gurJ9`,
	"gap2": `Badge-module__gap-2___k9zUR`,
	"gap4": `Badge-module__gap-4___wdX_g`,
	"gap5": `Badge-module__gap-5___M97ZU`,
	"gap6": `Badge-module__gap-6___TSjIp`,
	"gap8": `Badge-module__gap-8___p608d`,
	"gap10": `Badge-module__gap-10___pMxJY`,
	"gap12": `Badge-module__gap-12___FOZyJ`,
	"gap14": `Badge-module__gap-14___F0dss`,
	"gap16": `Badge-module__gap-16___hbMLM`,
	"gap18": `Badge-module__gap-18___WCSyg`,
	"gap20": `Badge-module__gap-20___miRpn`,
	"gap24": `Badge-module__gap-24___fP4OC`,
	"gap26": `Badge-module__gap-26___Z8Owk`,
	"gap30": `Badge-module__gap-30___aosAM`,
	"gap32": `Badge-module__gap-32___hca8A`,
	"gap40": `Badge-module__gap-40___RZQXM`,
	"gap50": `Badge-module__gap-50___PnCbV`,
	"flex1": `Badge-module__flex-1___UOdhl`,
	"flexNone": `Badge-module__flex-none___yZyBX`,
	"flexColumn": `Badge-module__flex-column___qEhnf`,
	"flexRow": `Badge-module__flex-row___pajwa`,
	"verticallyCentered": `Badge-module__vertically-centered___ob6X6`,
	"horizontallyCentered": `Badge-module__horizontally-centered___FwIyA`,
	"horizontallyEnd": `Badge-module__horizontally-end___Kx1LT`,
	"verticallyStart": `Badge-module__vertically-start___CiUPX`,
	"spaceBetween": `Badge-module__space-between___X3N_3`,
	"flexWrap": `Badge-module__flex-wrap___lcVzq`,
	"height100": `Badge-module__height-100___KzDVK`,
	"width50": `Badge-module__width-50___WznE0`,
	"width100": `Badge-module__width-100___ENdfv`,
	"cursorPointer": `Badge-module__cursor-pointer___qyLgy`,
	"cursorNotAllowed": `Badge-module__cursor-not-allowed___H0ifR`,
	"absoluteCentered": `Badge-module__absolute-centered___yvL_1`,
	"absolute": `Badge-module__absolute___qeYPD`,
	"relative": `Badge-module__relative___CWXhb`,
	"fixed": `Badge-module__fixed___qXost`,
	"visible": `Badge-module__visible___QqYC9`,
	"invisible": `Badge-module__invisible___zorwL`,
	"col90": `Badge-module__col-90___fND3g`,
	"colAuto": `Badge-module__col-auto___cy0yL`,
	"medicalTabs": `Badge-module__medical-tabs___v9RON`,
	"medicalTableNew": `Badge-module__medical-table-new___KpdNc`,
	"noPagination": `Badge-module__no-pagination___EmU8E`,
	"medicalTableEmpty": `Badge-module__medical-table-empty___YoB0s`,
	"iconBtn": `Badge-module__icon-btn___jZFUL`,
	"searchIcon": `Badge-module__search-icon___vd8u1`,
	"disableSelect": `Badge-module__disable-select___VOeEI`,
	"breakWord": `Badge-module__break-word___Yt9R5`,
	"popupClearBtn": `Badge-module__popup-clear-btn___dByfT`,
	"scrollMB20": `Badge-module__scroll-m-b-20___BwC6E`,
	"badge": `Badge-module__badge___b1jzG`,
	"default": `Badge-module__default___LlD1t`,
	"outline": `Badge-module__outline___bTho8`,
	"critical": `Badge-module__critical___L2PGO`,
	"escalated": `Badge-module__escalated___UXHn5`,
	"flagged": `Badge-module__flagged___gbuj0`,
	"edge": `Badge-module__edge___QS8SV`,
	"green": `Badge-module__green___KDjiT`,
	"yellow": `Badge-module__yellow___MTiDE`,
	"blue": `Badge-module__blue___h_EkL`,
	"orange": `Badge-module__orange___grOJw`,
	"red": `Badge-module__red___tt5sQ`,
	"statusDot": `Badge-module__statusDot___X_xJG`
};
module.exports = ___CSS_LOADER_EXPORT___;
